import { render, staticRenderFns } from "./sales-prems.vue?vue&type=template&id=218d8567"
import script from "./sales-prems.vue?vue&type=script&lang=js"
export * from "./sales-prems.vue?vue&type=script&lang=js"
import style0 from "./sales-prems.vue?vue&type=style&index=0&id=218d8567&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports